module.exports = __webpack_public_path__ + "img/logo_perfaccom.1dfa72fc.png";